import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dd41505"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "gallery" }
const _hoisted_2 = { class: "gallery-img-container" }
const _hoisted_3 = ["data-scroll-speed"]
const _hoisted_4 = ["src", "alt"]

import { onMounted, nextTick } from 'vue';
  import { Picture } from '@/models/PictureModel';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryView',
  props: {
    pictures: null
  },
  emits: ["rendered"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'rendered',): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    pictures: Picture[][];
  };

  

  

  onMounted(() => {
    nextTick(() => {
      window.addEventListener('load', () => {
        emit('rendered');
      })
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.pictures, (pictures, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${index}-pictures`,
          class: "gallery-line",
          "data-scroll": "",
          "data-scroll-speed": index%2 === 0 ? 1 : -1
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pictures, (pic, picIndex) => {
            return (_openBlock(), _createElementBlock("img", {
              key: `${index}-${picIndex}`,
              class: "gallery-img",
              src: require('@/assets/media/images/' + pic.name),
              alt: pic.alt
            }, null, 8, _hoisted_4))
          }), 128))
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})